import DocumentDetailForm from './document-detail-form.component.vue';

export { DocumentDetailForm };
